import { trackError } from '@billy/track-error'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { TargetType } from '../../../enums/eInvoicing'
import { QueryKeys } from '../../../enums/queryKeys'
import { PDP_NETWORK_TYPE } from '../constants'
import { disableEInvoicing } from '../query-api'

interface UseDisableEInvoicingOptions {
  onError?: (error: Error) => void
  onSuccess?: () => void
}

export const useDisableEInvoicing = ({ onError, onSuccess }: UseDisableEInvoicingOptions) => {
  const { organization } = useUserOrganization()

  const { mutateAsync, isLoading } = useMutation(
    [QueryKeys.EInvoicingDisabling, PDP_NETWORK_TYPE, organization?.id],
    () => {
      if (!organization?.id) {
        const errorMessage = 'Organization ID is required to disable e-invoicing'
        trackError(errorMessage)
        return Promise.reject(new Error(errorMessage))
      }
      return disableEInvoicing({
        network: PDP_NETWORK_TYPE,
        targetType: TargetType.BILLY,
        targetId: organization.id,
      })
    },
    { onError, onSuccess },
  )

  return {
    disableEInvoicing: mutateAsync,
    isProcessing: isLoading,
  }
}
